module.exports = __webpack_public_path__ + "static/media/FES_logotipo_color.83a73971.png";